import React, { useEffect, useRef, useState, useCallback } from 'react';
import { makerVariant } from '../variant-resolver.tsx';
const BASE = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/';
const ARROW_URL = `${BASE}image-arrow-dhxc1f5xkqb.png`;
interface Feature {
  id: string;
  name: string;
  description: string;
  asset: string;
  bg: string;
  learnMoreUrl: string | null;
}
type Category = 'CREATION' | 'DELIVERY' | 'EXPERIENCE';
const CATEGORY_ORDER: Category[] = ['CREATION', 'DELIVERY', 'EXPERIENCE'];
export const FeatureShowcase = () => {
  const categoryFeatures: Record<Category, Feature[]> = {
    CREATION: [{
      id: 'VISUAL EDITOR',
      name: 'Page builder',
      description: 'Drag, drop, design. Every section, every detail, exactly how you want it. No code, no limits.',
      asset: `${BASE}visual-editor-asset-jpwiehfgo3s.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/visual-editor-eu60gqp0mi.png`,
      learnMoreUrl: 'https://www.maker.co/pages'
    }, {
      id: 'AI BUILDER',
      name: 'AI builder',
      description: 'Describe what you want. The AI builds it. Done in minutes, not weeks.',
      asset: `${BASE}ai-builder-asset-7c97anpfl1c.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ai-builder-93a7m7we9zm.png`,
      learnMoreUrl: 'https://www.maker.co/'
    }, {
      id: 'STOREFRONT BUILDER',
      name: 'Storefront builder',
      description: 'Your whole catalogue, synced and always up to date. App-like, interactive, and seamless experiences.',
      asset: `${BASE}storefront-builder-asset-ej2s2sw4tpm.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/storefront-builder-p53zjme3a1.png`,
      learnMoreUrl: 'https://www.maker.co/nav'
    }, {
      id: 'MEDIA GENERATION',
      name: 'Media generation',
      description: 'Campaign-ready visuals, generated on brand. No shoot required.',
      asset: `${BASE}media-generation-asset-mh0phwxwak.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/media-generation-7n7vrxh4tg7.png`,
      learnMoreUrl: 'https://www.maker.co/media-generation'
    }, {
      id: 'FIGMA IMPORT',
      name: 'Figma import',
      description: "Your designs, live in minutes. Bring what you've already built straight into GreatStore.",
      asset: `${BASE}figma-import-asset-sjy39v6xjzh.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/figma-import-wcpgl5rqrz.png`,
      learnMoreUrl: 'https://www.maker.co/import-from-figma'
    }, {
      id: 'BRAND STYLE GUIDES',
      name: 'Brand guides',
      description: 'Your fonts, colours, and rules, stored and applied everywhere. Automatically on brand, always.',
      asset: `${BASE}brand-style-guides-asset-4ddkq5wlown.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/brand-style-guides-kkqags4pphh.png`,
      learnMoreUrl: 'https://www.maker.co/style-guide'
    }, {
      id: 'CATEGORY PAGES',
      name: 'Category pages',
      description: "Pages that do more than organise. They guide shoppers to exactly what they're looking for.",
      asset: `${BASE}category-pages-asset-ysciqmhnwj.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/category-pages-2qnqpj7xo02.png`,
      learnMoreUrl: 'https://www.maker.co/category-pages'
    }, {
      id: 'PRODUCT PAGES',
      name: 'Product pages',
      description: 'Every product, shown at its best. Rich, immersive, and built to convert.',
      asset: `${BASE}product-pages-asset-9d5m4arizz5.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/product-pages-82rj9g25iiq.png`,
      learnMoreUrl: 'https://www.maker.co/product-pages'
    }],
    DELIVERY: [{
      id: 'ENHANCED PRODUCT CONTENT',
      name: 'Enhanced content',
      description: 'Richer descriptions, smarter attributes, better context. Everything a shopper needs to say yes.',
      asset: `${BASE}enhanced-product-content-asset-d4cx9t0d32b.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/enhanced-product-content-4zd3nsxmg53.png`,
      learnMoreUrl: 'https://www.maker.co/enhanced-product-content'
    }, {
      id: 'A/B TESTING',
      name: 'A/B testing',
      description: 'Try as many variants as you want. Keep what works. Let your shoppers decide.',
      asset: `${BASE}ab-testing-asset-v834rojsdcs.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ab-testing-opugmic9k1.png`,
      learnMoreUrl: 'https://www.maker.co/ab-testing'
    }, {
      id: 'ANALYTICS',
      name: 'Insights',
      description: "See exactly how your store performs. What's working, what isn't, and what to do next.",
      asset: `${BASE}analytics-asset-iffrq7ns84p.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/analytics-octnomg8hg.png`,
      learnMoreUrl: 'https://www.maker.co/insights'
    }, {
      id: 'AD ANALYTICS',
      name: 'Ad spend analytics',
      description: 'See which campaigns turn clicks into customers, and which ones just burn budget. No more guessing.',
      asset: `${BASE}ad-analytics-asset-8xcg792ltco.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/ad-analytics-x5na9t6qc3q.png`,
      learnMoreUrl: 'https://leakypages.com/'
    }],
    EXPERIENCE: [{
      id: 'SHOPPABLE MEDIA',
      name: 'Shoppable media',
      description: 'Every image, every video a place to discover and buy without leaving the moment.',
      asset: `${BASE}shoppable-media-asset-d1x98eip07q.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/shoppable-media-n14s3rwgvhb.png`,
      learnMoreUrl: 'https://www.maker.co/shoppable-media'
    }, {
      id: 'VISUAL NAVIGATION',
      name: 'Visual navigation',
      description: 'Shoppers find what they want by seeing it, not searching for it.',
      asset: `${BASE}visual-navigation-asset-zztti5iog1q.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/visual-navigation-qpro0o3zxrr.png`,
      learnMoreUrl: 'https://www.maker.co/visual-navigation'
    }, {
      id: 'PERSONALIZATION',
      name: 'Personalization',
      description: 'Every shopper sees something made for them. The right product, the right moment, every time.',
      asset: `${BASE}personalization-asset-0308zohzd0yn.png`,
      bg: `https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/personalization-q4ww14jdn4.png`,
      learnMoreUrl: 'https://www.maker.co/personalized-landing-pages'
    }]
  };

  // ── Viewport ──────────────────────────────────────────────────────────────
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const handler = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const isMobile = windowWidth <= 767;
  const isAccordion = windowWidth <= 1024;
  const sidePad = isMobile ? '16px' : '24px';

  // ── State ─────────────────────────────────────────────────────────────────
  const [activeCat, setActiveCat] = useState<Category>('CREATION');
  const [activeFeatIdx, setActiveFeatIdx] = useState(0);
  const [hoveredFeatIdx, setHoveredFeatIdx] = useState<number | null>(null);

  // Preloader removed (PERF): feature images already load via the rendered
  // <img>/background-image through Cloudinary; the manual new Image() loop only
  // pulled unoptimized full-res S3 duplicates and competed with the hero LCP.

  // ── Refs ──────────────────────────────────────────────────────────────────
  const sectionRef = useRef<HTMLElement>(null);
  const autoplayTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isVisible = useRef(false);
  const hasStarted = useRef(false);
  const activeCatRef = useRef<Category>('CREATION');
  const activeFeatIdxRef = useRef(0);
  const userInteracted = useRef(false);
  const stopTimer = useCallback(() => {
    if (autoplayTimer.current !== null) {
      clearTimeout(autoplayTimer.current);
      autoplayTimer.current = null;
    }
  }, []);
  useEffect(() => {
    if (isAccordion) stopTimer();
  }, [isAccordion, stopTimer]);
  const switchTo = (cat: Category, featIdx: number) => {
    setActiveCat(cat);
    setActiveFeatIdx(featIdx);
    activeCatRef.current = cat;
    activeFeatIdxRef.current = featIdx;
  };
  const scheduleAdvanceRef = useRef<() => void>(() => {});
  useEffect(() => {
    scheduleAdvanceRef.current = () => {
      stopTimer();
      if (userInteracted.current) return;
      autoplayTimer.current = setTimeout(() => {
        const cat = activeCatRef.current;
        const featIdx = activeFeatIdxRef.current;
        const feats = categoryFeatures[cat];
        if (featIdx < feats.length - 1) {
          switchTo(cat, featIdx + 1);
        } else {
          const nextCat = CATEGORY_ORDER[(CATEGORY_ORDER.indexOf(cat) + 1) % CATEGORY_ORDER.length];
          switchTo(nextCat, 0);
        }
        if (isVisible.current) scheduleAdvanceRef.current();
      }, 10000);
    };
  });
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          isVisible.current = true;
          if (!isAccordion) {
            if (!hasStarted.current) {
              hasStarted.current = true;
              scheduleAdvanceRef.current();
            } else {
              scheduleAdvanceRef.current();
            }
          }
        } else {
          isVisible.current = false;
          stopTimer();
        }
      });
    }, {
      threshold: 0.1
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, [stopTimer]);
  const handleCategoryClick = (cat: Category) => {
    stopTimer();
    switchTo(cat, 0);
    if (isVisible.current) scheduleAdvanceRef.current();
  };
  useEffect(() => {
    const handler = (e: Event) => {
      const {
        tab
      } = (e as CustomEvent<{
        tab: Category;
      }>).detail;
      handleCategoryClick(tab);
    };
    window.addEventListener('greatstore-tab-goto', handler);
    return () => window.removeEventListener('greatstore-tab-goto', handler);
  }, []);
  const handleFeatureClick = (idx: number) => {
    userInteracted.current = true;
    stopTimer();
    switchTo(activeCat, idx);
  };

  // ── Shared category tabs ──────────────────────────────────────────────────
  const tabBar = <div className="feature-tabs-scroll" style={{
    borderTop: '1px solid rgba(9, 23, 23, 0.12)',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none'
  } as React.CSSProperties}>
      <div style={{
      maxWidth: '1360px',
      margin: '0 auto',
      paddingLeft: sidePad,
      paddingRight: sidePad,
      display: 'flex'
    }}>
        {CATEGORY_ORDER.map(cat => <button key={cat} data-name={`Category Tab ${cat}`} onClick={() => handleCategoryClick(cat)} aria-pressed={activeCat === cat} data-tracking-id={`btn-f891379ee6871325_${cat}`} style={{
        fontSize: '14px',
        letterSpacing: '0.02em',
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 500,
        color: '#091717',
        opacity: activeCat === cat ? 1 : 0.7,
        paddingTop: activeCat === cat ? '14px' : '15px',
        paddingRight: isMobile ? '40px' : '120px',
        paddingBottom: '14px',
        paddingLeft: 0,
        background: 'none',
        border: 'none',
        borderTop: activeCat === cat ? '2px solid #091717' : '1px solid transparent',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        transition: 'opacity 0.2s ease, border-top-width 0.2s ease, padding-top 0.2s ease'
      }}>
            {cat}
          </button>)}
      </div>
    </div>;

  // ── Desktop two-column layout ─────────────────────────────────────────────
  const desktopFeatures = <div style={{
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  }}>
      {/* All background images — always in DOM, toggled via opacity */}
      {CATEGORY_ORDER.flatMap(cat => categoryFeatures[cat].map((f, fi) => <div key={`bg-${cat}-${fi}`} style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: `url(${f.bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: cat === activeCat && fi === activeFeatIdx ? 1 : 0,
      transition: 'opacity 0.4s ease'
    }} />))}

      {/* Left-to-right gradient for left-column legibility */}
      <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 1,
      pointerEvents: 'none',
      background: 'linear-gradient(to right, rgba(9,23,23,0.6), rgba(9,23,23,0) 55%)'
    }} />

      {/* All category panels stacked in the same grid cell */}
      <div style={{
      position: 'relative',
      zIndex: 2,
      maxWidth: '1360px',
      margin: '0 auto',
      paddingLeft: '24px',
      paddingRight: '24px',
      display: 'grid'
    }}>
        {CATEGORY_ORDER.map(cat => {
        const features = categoryFeatures[cat];
        const isCatActive = cat === activeCat;
        return <div key={cat} style={{
          gridRow: 1,
          gridColumn: 1,
          display: 'flex',
          opacity: isCatActive ? 1 : 0,
          pointerEvents: isCatActive ? 'auto' : 'none',
          transition: 'opacity 0.25s ease'
        }}>
              {/* Left column — feature list for this category */}
              <div data-name="Feature List" style={{
            width: '30%',
            flexShrink: 0,
            paddingTop: '48px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
                {features.map((f, i) => <button key={f.id} data-name={`Feature ${f.name}`} data-tracking-id={`btn-1acf595df3ef8376_${f.id}`} onClick={() => isCatActive && handleFeatureClick(i)} onMouseEnter={() => isCatActive && setHoveredFeatIdx(i)} onMouseLeave={() => setHoveredFeatIdx(null)} style={{
              display: 'block',
              fontSize: '24px',
              lineHeight: '32px',
              opacity: i === activeFeatIdx ? 1 : hoveredFeatIdx === i ? 1 : 0.65,
              color: '#FCFAF6',
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              textAlign: 'left',
              whiteSpace: 'nowrap',
              transition: 'opacity 0.3s ease'
            }}>
                    {f.name}
                  </button>)}
              </div>

              {/* Right column — all feature detail panels stacked */}
              <div data-name="Feature Detail" style={{
            flex: 1,
            display: 'grid'
          }}>
                {features.map((f, fi) => <div key={f.id} style={{
              gridRow: 1,
              gridColumn: 1,
              display: 'flex',
              flexDirection: 'column',
              opacity: fi === activeFeatIdx ? 1 : 0,
              pointerEvents: fi === activeFeatIdx ? 'auto' : 'none',
              zIndex: fi === activeFeatIdx ? 1 : 0,
              position: 'relative',
              transition: 'opacity 0.25s ease'
            }}>
                    <div style={{
                paddingTop: '48px',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '32px',
                flexShrink: 0
              }}>
                      <p data-name="Feature Description" style={{
                  fontSize: '20px',
                  lineHeight: 1.45,
                  color: '#FCFAF6',
                  margin: 0,
                  maxWidth: '500px',
                  fontFamily: 'Instrument Sans, sans-serif',
                  fontWeight: 400
                }}>
                        {f.description}
                      </p>
                  {f.learnMoreUrl && <a href={f.learnMoreUrl} target="_blank" rel="noopener noreferrer" aria-label={`Learn more about ${f.name}`} className="learn-more-link feature-learn-more" data-name="Learn More Link" data-tracking-id="link-3d897e985da906b3" style={{
                  fontSize: '18px',
                  fontFamily: 'Instrument Sans, sans-serif',
                  fontWeight: 400,
                  color: '#FCFAF6',
                  textDecoration: 'none',
                  flexShrink: 0,
                  paddingBottom: '2px',
                  marginLeft: 'auto',
                  transition: 'opacity 0.2s ease'
                }} onMouseEnter={e => e.currentTarget.style.opacity = '0.5'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                        Learn more about {f.name}{' '}
                        <img src={ARROW_URL} alt="" aria-hidden="true" style={{
                    display: 'inline-block',
                    width: '1em',
                    height: '1em',
                    objectFit: 'contain',
                    verticalAlign: 'middle',
                    marginLeft: '4px',
                    filter: 'brightness(0) invert(1)'
                  }} />
                      </a>}
                    </div>
                    <div style={{
                position: 'relative',
                height: '600px',
                flexShrink: 0,
                overflow: 'visible'
              }}>
                      <img src={f.asset} alt={f.id} loading="lazy" decoding="async" className="feature-mockup-img" style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '1000px',
                  height: '600px',
                  objectFit: 'contain',
                  display: 'block'
                }} />
                    </div>
                  </div>)}
              </div>
            </div>;
      })}
      </div>
    </div>;

  // ── Accordion layout (mobile + tablet ≤1024px) ────────────────────────────
  const accordionFeatures = <div style={{
    backgroundColor: '#091717'
  }}>
      {categoryFeatures[activeCat].map((f, i) => {
      const isExpanded = i === activeFeatIdx;
      return <div key={f.id} data-name={`Accordion Item ${f.name}`}>
            <button onClick={() => {
          if (isExpanded) {
            stopTimer();
            setActiveFeatIdx(-1);
            activeFeatIdxRef.current = -1;
          } else {
            handleFeatureClick(i);
          }
        }} aria-expanded={isExpanded} data-tracking-id={`btn-1acf595df3ef8376_${f.id}`} style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: `14px ${sidePad}`,
          background: 'none',
          border: 'none',
          borderBottom: '1px solid rgba(252,250,246,0.1)',
          cursor: 'pointer'
        }}>
              <span style={{
            fontSize: '16px',
            color: '#FCFAF6',
            opacity: isExpanded ? 1 : 0.5,
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            transition: 'opacity 0.3s ease'
          }}>
                {f.name}
              </span>
              <span aria-hidden="true" style={{
            fontSize: '24px',
            lineHeight: 1,
            color: '#FCFAF6',
            flexShrink: 0,
            marginLeft: '16px',
            opacity: isExpanded ? 1 : 0.4,
            transition: 'opacity 0.3s ease'
          }}>
                {isExpanded ? '−' : '+'}
              </span>
            </button>

            <div style={{
          maxHeight: isExpanded ? '800px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.4s ease'
        }}>
              {/* Full-width background + asset */}
              <div style={{
            backgroundImage: `url(${f.bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            paddingTop: '16px',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingBottom: 0
          }}>
                <img src={f.asset} alt={f.id} loading="lazy" style={{
              display: 'block',
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              objectPosition: 'bottom',
              verticalAlign: 'bottom'
            }} />
              </div>
              {/* Description + Learn more */}
              <div style={{
            padding: '16px',
            backgroundColor: '#091717',
            borderBottom: '1px solid rgba(252,250,246,0.1)'
          }}>
                <p style={{
              fontSize: '16px',
              lineHeight: 1.5,
              color: '#FCFAF6',
              margin: 0,
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400
            }}>
                  {f.description}
                </p>
                {f.learnMoreUrl && <a href={f.learnMoreUrl} target="_blank" rel="noopener noreferrer" aria-label={`Learn more about ${f.name}`} data-tracking-id="link-3d897e985da906b3" style={{
              display: 'inline-block',
              marginTop: '10px',
              fontSize: '14px',
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              color: '#FCFAF6',
              textDecoration: 'none',
              transition: 'opacity 0.2s ease'
            }} onMouseEnter={e => e.currentTarget.style.opacity = '0.5'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                    Learn more about {f.name}{' '}
                    <img src={ARROW_URL} alt="" aria-hidden="true" style={{
                display: 'inline-block',
                width: '1em',
                height: '1em',
                objectFit: 'contain',
                verticalAlign: 'middle',
                marginLeft: '4px',
                filter: 'brightness(0) invert(1)'
              }} />
                  </a>}
              </div>
            </div>
          </div>;
    })}
    </div>;
  return <section ref={sectionRef} id="features" data-name="Feature Showcase" data-nav-theme="light" onMouseEnter={stopTimer} onMouseLeave={() => {
    if (isVisible.current && !userInteracted.current) scheduleAdvanceRef.current();
  }} onFocusCapture={stopTimer} style={{
    backgroundColor: '#FCFAF6',
    paddingTop: '100px'
  }}>
      {/* Title area — responsive */}
      <div style={{
      maxWidth: '1360px',
      margin: '0 auto',
      paddingLeft: sidePad,
      paddingRight: sidePad,
      display: 'flex',
      flexDirection: isAccordion ? 'column' : 'row',
      alignItems: isAccordion ? 'flex-start' : 'flex-end',
      gap: isAccordion ? '16px' : '120px',
      marginBottom: isMobile ? '24px' : '48px'
    }}>
        <div style={{
        flex: isAccordion ? undefined : '7 0 0',
        minWidth: 0
      }}>
          <h2 style={{
          fontSize: isAccordion ? '40px' : makerVariant('featureFontSize', 'clamp(52px, 7vw, 92px)'),
          lineHeight: 1.05,
          color: '#091717',
          margin: 0,
          fontWeight: 400
        }} dangerouslySetInnerHTML={{
          __html: makerVariant('featureHeroTitle', "All your store needs <span class='font-serif italic'>in one place</span>")
        }} />
        </div>
        {makerVariant('featureHeroShowDescription', 'true') as string !== 'false' && <div style={{
        flex: isAccordion ? undefined : '3 0 0',
        minWidth: 0,
        paddingBottom: isAccordion ? 0 : '3px'
      }}>
            <p data-name="Section Description" style={{
          fontSize: isAccordion ? isMobile ? '16px' : '14px' : 'clamp(18px, 1.5vw, 24px)',
          lineHeight: 1.4,
          color: '#091717',
          margin: 0,
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>
              GreatStore gives you every tool to serve the shoppers who browse and the AI agents who buy for them.
            </p>
          </div>}
      </div>

      {tabBar}

      {isAccordion ? accordionFeatures : desktopFeatures}
    </section>;
};